<app-card-info
  [message]="getMessage()"
  [information]="customMessage === undefined ? getInformation() : undefined"
  [button]="getButton()"
  [showAsColumn]="false"
  [showWarningIcon]="true"
  [showWarningButton]="locked"
  (clickButtonEvent)="clickButton()"
></app-card-info>
